import { CommonService } from 'src/app/services/common.service';
import { CoAdminModel } from './../model/CoAdmin.model';
import { forkJoin } from 'rxjs';
import { AdminService } from './../services/admin.service';
import { ApiService } from './../services/api.service';
import { AppConstant } from './../config/app.constant';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  HostListener,
} from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIs } from '../config/api.constant';
import { AppStateProvider } from '../providers/app-state.provider';
import { TAModel } from '../model/TA.model';
import { tap, mergeMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';

@Component({
  standalone: false,
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, AfterViewInit {
  entryGate: any = [];
  meetingRoomAccess: any = [];
  deskAccess: any = [];
  privateSuiteAccess: any = [];
  accessPointChanged1 = [];
  accessPointChanged2 = [];
  useraccessPointChanged1 = [];
  useraccessPointChanged2 = [];
  name: boolean;
  email: boolean;
  mobile: boolean;
  dept;
  url: string;
  deptList: any;
  fullname1 = '';
  fullname2 = '';
  accessPointList: any;
  emailId1 = '';
  emailId2 = '';
  phoneNumber1 = '';
  phoneNumber2 = '';
  departmentName1: any;
  departmentName2: any;
  add1: boolean = true;
  add2: boolean = true;
  edit: boolean = false;
  closeResult: string;
  meetingNav: any;
  token: string;
  activeAdmin: number = null;
  taDetails = new TAModel();
  coAdmin1 = new CoAdminModel();
  coAdmin2 = new CoAdminModel();
  isCoAdmin1Exists: boolean = false;
  isCoAdmin2Exists: boolean = false;
  fieldErrors: any = [];
  initials: string = '';
  searchDept: string = '';
  initials1: string = '';
  initials2: string = '';
  moreDetails: any;
  updatedAccessPoints: any = [];
  tempAccessPoints: any[];
  canChangeAccess: boolean = true;
  isAdmin = localStorage.getItem(AppConstant.localStorage.isAdmin);
  operation = true;
  shown: boolean = false;
  disableAdd: boolean = false;
  profileDrawer: boolean = false;

  constructor(
    private modalService: NgbModal,
    private appStateSrv: AppStateProvider,
    private apiService: ApiService,
    private adminSrv: AdminService,
    private router: Router,
    private adalService: MsAdalAngular6Service,
    private commonService: CommonService
  ) { }
  @HostListener('click', ['$event']) onClick(e) {
    if (
      !e.target.className.includes('dots') &&
      !e.target.className.includes('dot')
    )
      this.profileDrawer = false;
  }

  @ViewChild('adminAccess', { static: false }) adminAccess: ElementRef;
  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'custom-class',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  showAccess(canChange: boolean) {
    if (this.accessPointList.list.length > 0) {
      this.canChangeAccess = canChange;
      this.open(this.adminAccess);
    }
  }

  getDepartmentDetails() {
    this.url = APIs.getDepartmentList;

    this.apiService.get(this.url, '').subscribe({
      next: (response: any) => {
        this.deptList = response.list;
        console.log('deptList', this.deptList.list);
        this.getAllCoAdmins();
        this.getTADetails();
        // this.members.list.departmentname=this.deptInfo.data.department
      },
      error: (err) => console.log('error', err)
    });
  }
  ngOnInit(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    this.meetingNav = [
      {
        index: '10',
        name: 'Profile',
        link: '/profile',
      },
    ];

    const route = {
      index: '10',
      name: 'Profile',
      link: '/profile',
    };
    this.appStateSrv.setSideNavState(route);
    this.adminSrv.getadmindetails().subscribe(details => {
      localStorage.setItem(AppConstant.localStorage.tenantId, details.data.tenantId);
      localStorage.setItem(AppConstant.localStorage.userId, details.data.id);
      localStorage.setItem(AppConstant.localStorage.adminName, details.data.adminName);
      this.getDepartmentDetails();
      this.getAccessPointList();
      this.getTenantMoreDetails();
    })

  }
  ngAfterViewInit() {
    this.accodionClick('toggle-1-header', true);
  }
  getTenantMoreDetails() {
    this.adminSrv.getTenantMoreDetails().subscribe((response) => {
      console.log('more details ', response);
      this.moreDetails = {
        creditPointAllocated: response.creditPointAllocated,
        creditPointUsed: response.creditPointUsed,
        fourWheelParking: response.fourWheelParking,
        roomType: response.roomType,
        twoWheelParking: response.twoWheelParking,
      };
    });
  }

  getAllCoAdmins() {
    this.adminSrv.getCoAdmins().subscribe((coAdmins) => {
      if (coAdmins.length > 0) {
        this.fullname1 = coAdmins[0].adminName;
        this.emailId1 = coAdmins[0].adminEmailId;
        this.phoneNumber1 = coAdmins[0].phoneNumber;
        this.departmentName1 = this.deptList.find(
          (dept) => dept.id === coAdmins[0].departmentId
        ).department;
        this.add1 = false;
        this.coAdmin1.name = coAdmins[0].adminName;
        this.coAdmin1.emailId = coAdmins[0].adminEmailId;
        this.coAdmin1.alternateEmailId = ''; //coAdmins[0].alternateEmailId;
        this.coAdmin1.department = this.deptList.find(
          (dept) => dept.id === coAdmins[0].departmentId
        ).department;
        this.coAdmin1.deptId = coAdmins[0].departmentId;
        this.coAdmin1.mobileNumber = coAdmins[0].phoneNumber;
        this.coAdmin1.id = coAdmins[0].id;
        this.coAdmin1.profileUrl = coAdmins[0].profileUrl;
        this.initials1 = this.generateInitials(coAdmins[0].adminName);
        this.isCoAdmin1Exists = true;
        if (coAdmins[1]) {
          this.fullname2 = coAdmins[1].adminName;
          this.emailId2 = coAdmins[1].adminEmailId;
          this.phoneNumber2 = coAdmins[1].phoneNumber;
          this.departmentName2 = this.deptList.find(
            (dept) => dept.id === coAdmins[1].departmentId
          ).department;
          this.add2 = false;
          this.coAdmin2.name = coAdmins[1].adminName;
          this.coAdmin2.emailId = coAdmins[1].adminEmailId;
          this.coAdmin2.alternateEmailId = ''; //coAdmins[1].alternateEmailId;
          this.coAdmin2.department = this.deptList.find(
            (dept) => dept.id === coAdmins[1].departmentId
          ).department;
          this.coAdmin2.deptId = coAdmins[1].departmentId;
          this.coAdmin2.mobileNumber = coAdmins[1].phoneNumber;
          this.coAdmin2.id = coAdmins[1].id;
          this.isCoAdmin2Exists = true;
          this.coAdmin2.profileUrl = coAdmins[1].profileUrl;
          this.initials2 = this.generateInitials(coAdmins[1].adminName);
        }
        let userIdArr = [{ userId: this.coAdmin1.id, coAdminNumber: 1 }];
        if (coAdmins[1])
          userIdArr.push({ userId: this.coAdmin2.id, coAdminNumber: 2 });
        // this.getAccessPoints(userIdArr);
      }
    });
  }
  getAccessPoints(userIdArr) {
    console.log('updatedAccessPoints userIdArr', userIdArr);

    this.updatedAccessPoints = [];
    if (userIdArr.length === 2) {
      forkJoin([
        this.adminSrv.getTenantSavedAccessPoints(userIdArr[0].userId),
        this.adminSrv.getUserAccessPointList(userIdArr[1].userId),
      ]).subscribe(([coAdmin1Access, coAdmin2Access]) => {
        console.log(
          coAdmin1Access,
          coAdmin2Access,
          '[coAdmin1Access, coAdmin2Access]'
        );
        let temp = [
          {
            userId: userIdArr[0].userId,
            accesspoints: coAdmin1Access.list,
            adminNumber: userIdArr[0].coAdminNumber,
          },
          {
            userId: userIdArr[1].userId,
            accesspoints: coAdmin2Access.list,
            adminNumber: userIdArr[1].coAdminNumber,
          },
        ];
        this.updatedAccessPoints = [...temp];
        console.log('updatedAccessPoints 2', this.updatedAccessPoints);
      });
    } else {
      this.adminSrv
        .getUserAccessPointList(userIdArr[0].userId)
        .subscribe((response) => {
          console.log(response, '[coAdmin1Access]');
          if (response.list.length > 0) {
            let temp = {
              userId: userIdArr[0].userId,
              accesspoints: response.list,
              adminNumber: userIdArr[0].coAdminNumber,
            };
            this.updatedAccessPoints.push(temp);
            console.log('updatedAccessPoints 1', this.updatedAccessPoints);
          }
        });
    }
  }
  addCoAdmin(coAdminNumber) {
    var userId = null;
    if (coAdminNumber == 1) {
      if (this.coAdmin1?.id) {
        userId = this.coAdmin1?.id;
      }
    } else if (coAdminNumber == 2) {
      if (this.coAdmin2?.id) {
        userId = this.coAdmin2?.id;
      }
    }
    this.disableAdd = true;
    const requestData = {
      adminName: coAdminNumber === 1 ? this.fullname1 : this.fullname2,
      adminEmailId: coAdminNumber === 1 ? this.emailId1 : this.emailId2,
      phoneNumber: coAdminNumber === 1 ? this.phoneNumber1 : this.phoneNumber2,
      departmentId:
        this.dept == undefined
          ? coAdminNumber === 1
            ? this.coAdmin1.deptId
            : this.coAdmin2.deptId
          : this.dept.id,
      tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      isAdmin: false,
      id: userId,
    };
    if (requestData.id) {
      this.adminSrv.updateAdmin(requestData).subscribe((response: any) => {
        this.disableAdd = false;
        console.log('coadmin response', response);
        const adminId = response.data.userId;
        const isValid = response.data.isValid;

        if (coAdminNumber === 1) this.add1 = false;
        else this.add2 = false;
        if (response) {
          const payload = {
            userId: adminId,
            sendEmail: true,
            accessPointList:
              coAdminNumber === 1
                ? this.useraccessPointChanged1
                : this.useraccessPointChanged2,
          };
          //this.adminSrv.updateUserAccessPoint(payload).subscribe(response => {
          //console.log('coadmin access response', response);
          if (coAdminNumber === 1) {
            this.initials1 = this.generateInitials(
              coAdminNumber === 1 ? this.fullname1 : this.fullname2
            );
          } else {
            this.initials2 = this.generateInitials(
              coAdminNumber === 1 ? this.fullname1 : this.fullname2
            );
          }
          this.getAllCoAdmins();
          //window.location.reload();
          //})
        }
      });
    } else {
      this.adminSrv.saveAdmin(requestData).subscribe((response: any) => {
        console.log('coadmin response', response);
        if (response.isValid) {
          const adminId = response.data.userId;
          const isValid = response.data.isValid;
          this.disableAdd = false;
          if (coAdminNumber === 1) this.add1 = false;
          else this.add2 = false;
          // if (response) {
          //   const payload = {
          //     userId: adminId,
          //     sendEmail: true,
          //     accessPointList: coAdminNumber === 1 ? this.useraccessPointChanged1 : this.useraccessPointChanged2
          //   }
          // this.adminSrv.updateUserAccessPoint(payload).subscribe(response => {
          //   console.log('coadmin access response', response);
          if (coAdminNumber === 1) {
            this.initials1 = this.generateInitials(
              coAdminNumber === 1 ? this.fullname1 : this.fullname2
            );
          } else {
            this.initials2 = this.generateInitials(
              coAdminNumber === 1 ? this.fullname1 : this.fullname2
            );
          }
          this.getAllCoAdmins();
          //   // window.location.reload();
          // })
          //}
        }
      });
    }
    this.disableAdd = false;
    // forkJoin([this.adminSrv.addEmployee(requestData),
    // this.adminSrv.updateUserAccessPoint(this.useraccessPointChanged1)])
    //   .subscribe(([call1Response, call2Response]) => {
    //     console.log('response of forkjoin ', [call1Response, call2Response]);
    //     this.add2 = false;
    //   });
  }

  getAccessPointList() {
    this.url = APIs.getTenantSavedAccessPoints;
    this.apiService
      .get(this.url, {
        tenantId: localStorage.getItem(AppConstant.localStorage.tenantId),
      })
      .subscribe({
        next: (response: any) => {
          this.accessPointList = response;
          this.tempAccessPoints = [...this.accessPointList.list];
          this.setAccessPoint();
          console.log('accessPointList', this.accessPointList);
        },
        error: (err) => console.log('error', err)
      });
  }

  cancelAdd() {
    window.location.reload();
  }

  changeAccess(eg, module, i, status?) {
    return;
    console.log('status ', eg, module, i, status);
    this.canChangeAccess =
      (this.activeAdmin == 1 && this.add1) ||
      (this.activeAdmin == 2 && this.add2);
    if (!this.canChangeAccess) return;
    const data = eg;
    if (module === 'entryGate') {
      const index = this.entryGate.indexOf(data);
      data.selected = status === undefined ? !data.selected : status;
      this.entryGate[index] = data;
      if (data.selected) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        } else {
          this.accessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        }
      }
      if (!data.selected) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.splice(i, 1);
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        } else {
          this.accessPointChanged2.splice(i, 1);
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        }
      }
    } else if (module === 'meetingRoomAccess') {
      let index = this.meetingRoomAccess.indexOf(data);
      data.selected = !data.selected;
      this.meetingRoomAccess[index] = data;
      if (data.selected == true) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        } else {
          this.accessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        }
      }
      if (data.selected === false) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.splice(i, 1);
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        } else {
          this.accessPointChanged2.splice(i, 1);
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        }
      }
    } else if (module == 'deskAccess') {
      let index = this.deskAccess.indexOf(data);
      data.selected = !data.selected;
      this.deskAccess[index] = data;
      if (data.selected == true) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        } else {
          this.accessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        }
      }
      if (data.selected == false) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.splice(i, 1);
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        } else {
          this.accessPointChanged2.splice(i, 1);
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        }
      }
    } else if (module === 'privateSuiteAccess') {
      let index = this.privateSuiteAccess.indexOf(data);
      data.selected = !data.selected;
      this.privateSuiteAccess[index] = data;
      if (data.selected == true) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        } else {
          this.accessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
          });
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: true,
          });
        }
      }
      if (data.selected == false) {
        if (this.activeAdmin === 1) {
          this.accessPointChanged1.splice(i, 1);
          this.useraccessPointChanged1.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        } else {
          this.accessPointChanged2.splice(i, 1);
          this.useraccessPointChanged2.push({
            type: data.type,
            AccessPointId: data.id,
            CreatedBy: data.createdBy,
            hasAccess: false,
          });
        }
      }
    }
  }

  setAccessPoint() {
    this.entryGate = [];
    this.meetingRoomAccess = [];
    this.privateSuiteAccess = [];
    this.deskAccess = [];
    this.accessPointList.list.forEach((data) => {
      if (data.accessPoint.type === 'entry_gate') {
        data.selected = false;
        this.entryGate.push(data);
      } else if (data.accessPoint.type === 'meeting_room') {
        data.selected = false;
        this.meetingRoomAccess.push(data);
      } else if (data.accessPoint.type === 'team_room') {
        data.selected = false;
        this.privateSuiteAccess.push(data);
      } else if (data.accessPoint.type === 'desk') {
        data.selected = false;
        this.deskAccess.push(data);
      }
    });
  }

  enterName(field) {
    if (field == 'name') {
      this.name = !this.name;
      if (this.fullname1.length != 0) {
        this.name = true;
      }
    }
    if (field == 'name2') {
      this.name = !this.name;
      if (this.fullname2.length != 0) {
        this.name = true;
      }
    }
    if (field == 'email') {
      this.email = !this.email;
      if (this.emailId1.length != 0) {
        this.email = true;
      }
    }
    if (field == 'email2') {
      this.email = !this.email;
      if (this.emailId2.length != 0) {
        this.email = true;
      }
    }
    if (field == 'mobile') {
      this.mobile = !this.mobile;
      if (this.phoneNumber1.length != 0) {
        this.mobile = true;
      }
      if (this.mobile) {
        var x = document.getElementById('prefix');
        x.innerHTML = '+91';
      } else if (!this.mobile) {
        var x = document.getElementById('prefix');
        x.innerHTML = '';
      }
    }
    if (field == 'mobile2') {
      this.mobile = !this.mobile;
      if (this.phoneNumber2.length != 0) {
        this.mobile = true;
      }
      if (this.mobile) {
        var x = document.getElementById('prefix');
        x.innerHTML = '+91';
      } else if (!this.mobile) {
        var x = document.getElementById('prefix');
        x.innerHTML = '';
      }
    }
    if (field == 'department') {
      this.dept = !this.dept;
      if (this.departmentName1.length != 0) {
        this.dept = true;
      }
      if (this.departmentName2.length != 0) {
        this.dept = true;
      }
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }
  openPopover(popover) {
    this.searchDept = '';
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  formValidator(
    adminNumber: number,
    type: string = 'add'
  ): { valid: boolean; errFields: any } {
    console.log('came here with ', adminNumber);

    const validate = (name, email, phone, dept) => {
      let errFields = [];
      if (type == 'name' + adminNumber || type == 'add')
        if (!name || !/^[a-zA-Z ]{2,50}$/.test(name)) {
          if (name.length > 50) {
            const i = errFields.indexOf('name' + adminNumber + 'len');
            if (i > -1) errFields.splice(i, 1);
            // errFields.push('name' + adminNumber + 'len');
          } else {
            const i = errFields.indexOf('name' + adminNumber + 'len');
            if (i > -1) errFields.splice(i, 1);
          }
          const i = errFields.indexOf('name' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
          errFields.push('name' + adminNumber);
        } else {
          const i = errFields.indexOf('name' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'email' + adminNumber || type == 'add')
        if (
          !email ||
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
        ) {
          const i = errFields.indexOf('email' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
          errFields.push('email' + adminNumber);
        } else {
          const i = errFields.indexOf('email' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'phone' + adminNumber || type == 'add')
        if (!phone || !/^\d{10}$/.test(phone)) {
          const i = errFields.indexOf('phone' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
          errFields.push('phone' + adminNumber);
        } else {
          const i = errFields.indexOf('phone' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
        }
      if (type == 'dept' + adminNumber || type == 'add')
        if (!dept || dept == undefined || dept == '') {
          const i = errFields.indexOf('dept' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
          errFields.push('dept' + adminNumber);
        } else {
          const i = errFields.indexOf('dept' + adminNumber);
          if (i > -1) errFields.splice(i, 1);
        }
      if (errFields.length > 0) return { valid: false, errFields: errFields };
      else return { valid: true, errFields: [] };
    };

    switch (adminNumber) {
      case 1:
        return validate(
          this.fullname1,
          this.emailId1,
          this.phoneNumber1,
          this.departmentName1
        );
      case 2:
        return validate(
          this.fullname2,
          this.emailId2,
          this.phoneNumber2,
          this.departmentName2
        );
      default:
        return { valid: false, errFields: [] };
    }
  }

  inputModelChange(adminNumber: number, type: string) {
    this.textToLower(adminNumber);
    const formStatus = this.formValidator(adminNumber, type);
    this.fieldErrors = [];
    if (!formStatus.valid) this.fieldErrors = formStatus.errFields;
    return;
  }

  setDepartment1(dept) {
    console.log('dept', dept);

    this.dept = dept;
    this.departmentName1 = dept.department;
    this.searchDept = '';
    // this.inputModelChange(1);
  }
  setDepartment2(dept) {
    this.dept = dept;
    this.departmentName2 = dept.department;
    this.searchDept = '';
    // this.inputModelChange(2);
  }
  addClick(type: string, coAdminNumber: number, e) {
    e.preventDefault();
    console.log('addclick', type, coAdminNumber);

    switch (type) {
      case 'add':
        const formStatus = this.formValidator(coAdminNumber);
        if (!formStatus.valid) {
          console.log('Error', formStatus);
          this.fieldErrors = formStatus.errFields;
          console.log('fieldErrors', this.fieldErrors);
          return;
        }
        this.fieldErrors = [];

        this.addCoAdmin(coAdminNumber);
        break;
      case 'edit':
        this.canChangeAccess = true;

        if (coAdminNumber === 1) this.add1 = true;
        else this.add2 = true;

        break;

      default:
        break;
    }

    console.log('status', this.add1, this.add2);
  }

  drawerClick(adminNumber: number, status?) {
    console.log('clicked', adminNumber, status);
    this.activeAdmin = adminNumber;
    if (status && this.updatedAccessPoints.length > 0) {
      const accessPointList = this.updatedAccessPoints.filter(
        (accessPoints) => accessPoints.adminNumber == adminNumber
      )[0]
        ? this.updatedAccessPoints.filter(
          (accessPoints) => accessPoints.adminNumber == adminNumber
        )[0].accesspoints
        : [];
      if (accessPointList.length == 0) {
        this.accessPointList = null;
        this.getAccessPointList();
        return;
      }
      accessPointList.forEach((element) => {
        this.accessPointList.list = [...this.tempAccessPoints].map((access) => {
          if (access.id == element.accessPointId) access.selected = true;
          return access;
        });
      });
    }
  }

  getTADetails() {
    this.adminSrv
      .getAdminData()
      .pipe(
        tap((details) => {
          console.log(this.adminSrv.getAdminData(), 'asdasdsadasds');
          this.taDetails.name = details.adminName;
          this.taDetails.emailId = details.adminEmailId;
          this.taDetails.mobileNumber = details.phoneNumber;
          this.taDetails.alternateEmailId = details.alternateEmailId;

          if (details.departmentId)
            this.taDetails.department = this.deptList.find(
              (dept) => details.departmentId === dept.id
            ).department;
          this.taDetails.id = details.userId;
          this.taDetails.image = details.profileUrl;
          this.initials = this.generateInitials(this.taDetails.name);
          console.log('came here', this.initials);
        }),
        mergeMap((details) =>
          this.adminSrv.getTenantSavedAccessPoints(details.tenantId)
        )
      )
      .subscribe((response) => {
        console.log('responseTA', response);
        console.log('came here', this.initials);
        if (response && response.list && response.list.length > 0) {
          response.list.foreach((access) => {
            this.accessPointList.list = [...this.tempAccessPoints].map((e) => {
              if (access.accessPointId == e.id) e.selected = true;
              return e;
            });
          });
        }
      });
  }

  generateInitials(fullName: string): string {
    if (fullName !== '' && fullName !== null && fullName !== undefined)
      return (
        fullName.split(' ')[0].charAt(0).toUpperCase() +
        ' ' +
        (fullName.split(' ')[1] === undefined || fullName.split(' ')[1] === null
          ? ''
          : fullName.split(' ')[1].charAt(0).toUpperCase())
      );
    else return '';
  }

  removeCoAdmin(coAdminNumber: number) {
    let id = null;
    if (coAdminNumber == 1) id = this.coAdmin1.id;
    else id = this.coAdmin2.id;
    this.adminSrv.removeCoAdmin(id).subscribe((response) => {
      console.log('response');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }



  logout() {
    this.commonService.logoutToken().subscribe((res) => {
      if (res) {
        localStorage.clear();
        if (this.adalService.isAuthenticated == true) {
          this.adalService.logout();
        }
        this.router.navigateByUrl('').then(() => {
          window.location.reload();
        });
      }
    });

  }
  navigate() {
    this.router.navigateByUrl('/change-password');
  }
  classChange() {
    const change = document.getElementById('classChange');
    if (change) change.className = 'accordian-panel1';
  }

  accodionClick(id: string, status: boolean) {
    ['toggle-1-header', 'toggle-2-header', 'toggle-3-header'].forEach((toggleId) => {
      const el = document.getElementById(toggleId);
      if (el?.classList) el.classList.remove('open-state');
    });
    const target = document.getElementById(id);
    if (target?.classList) {
      if (status) target.classList.add('open-state');
      else target.classList.remove('open-state');
    }
  }
  textToLower(type) {
    if (type == 1) this.emailId1 = this.emailId1.toLowerCase();
    if (type == 2) this.emailId2 = this.emailId2.toLowerCase();
  }
}
